function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { createInstance } from 'i18next'; // import context from './context';

import GenericLazyString from '../lazy-gettext/GenericLazyString';
var LOCALE_FROM_FILENAME_REGEX = /^\.\/(.*)\.json$/;
var i18n = createInstance();
export var setupI18n = function setupI18n(context) {
  /**
  * Locale files generated by transifex tooling always use '_' as the region separator,
  * but i18next expects them to be to be separated by '-'.
  * @param {string} locale the locale string to normalize
  */
  var normalizeLocale = function normalizeLocale(locale) {
    return locale.replace('_', '-');
  };

  var loadLocales = function loadLocales(context) {
    var translations = {};
    context.keys().forEach(function (locale) {
      var _locale$match = locale.match(LOCALE_FROM_FILENAME_REGEX),
          _locale$match2 = _slicedToArray(_locale$match, 2),
          localeName = _locale$match2[1];

      var normalizedLocaleName = normalizeLocale(localeName);
      translations[normalizedLocaleName] = {
        translation: context(locale)
      };
    });
    return translations;
  };

  var translations = loadLocales(context);
  /**
  * I18n initialization
  *  - Uses all available translations downloaded from Transifex at build time.
  *  - If a locale is provided like 'es-ES' is not found, then an 'es' translation will be looked up.
  *  - If no 'es' translation is found, then an 'en' translation will be looked up
  *  - If no 'en' translation is found, then the provided key will be returned as is.
  */

  i18n.init({
    resources: translations,
    lng: 'en',
    fallbackLng: 'en',
    returnEmptyString: false,
    keySeparator: false,
    nsSeparator: false,
    pluralSeparator: false,
    contextSeparator: false,
    interpolation: {
      escapeValue: false,
      prefix: '%(',
      suffix: ')s'
    }
  });
  /**
  * isPlural returns true if the passed in count should be expressed as a plural in the current active
  * language
  *
  * @param {number} count a quantity to check if it should be expressed as plural.
  */

  var isPlural = function isPlural(count) {
    return i18n.services.pluralResolver.getSuffix(i18n.language, count) === 'plural';
  };
  /**
  * gettext is the main translation function.
  *
  * @param {string} key the key, string or template string of the message to translate
  * @param {object} interpolation an object used for interpolation in the template string.
  * @returns a GenericLazyString instance that will resolve to the active language when used.
  */


  var gettext = function gettext(key, interpolation) {
    return new GenericLazyString(function () {
      if (!interpolation) {
        /*
        * When no interpolation object is provided, we need to preserve the placeholders
        * This is for backward compatibility with existing code relying on this behavior.
        */
        return i18n.t(key, {
          interpolation: {
            suffix: '####',
            prefix: '####'
          }
        });
      }

      return i18n.t(key, interpolation);
    });
  };
  /**
  * ngettext returns singularString is the amount passed in 'number' qualifies as singular
  * given the set locale, returns pluralString otherwise.
  *
  * @param {string} singularString String to display if count is singular.
  * @param {string} pluralString String to display if count is plural.
  * @param {number} count a quantity to check if it should be expressed as plural.
  */


  var ngettext = function ngettext(singularString, pluralString, count) {
    return isPlural(count) ? pluralString : singularString;
  };
  /**
  * lazyGettex is just re-ing gettext for backward compatibility. You should use gettext() instead of this.
  */


  var lazyGettext = gettext;
  /**
  * Changes the active language for all subsequent calls to gettext()
  *
  * @param {string} language the new desired language for translations
  */

  var setLanguage = function setLanguage(language) {
    return i18n.changeLanguage(normalizeLocale(language));
  };

  return {
    normalizeLocale: normalizeLocale,
    isPlural: isPlural,
    gettext: gettext,
    ngettext: ngettext,
    lazyGettext: lazyGettext,
    setLanguage: setLanguage
  };
};